// "Acting as a client" state for an accountant with FULL access managing a client's wallets.
// Stored in sessionStorage (not localStorage) so it never silently survives into a later,
// unrelated session on the same browser/device - closing the tab/browser ends it.
const STORAGE_KEY = "actingAsClient";

export const getActingAsClient = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const setActingAsClient = (clientUserId, clientEmail) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ clientUserId, clientEmail }));
  } catch (e) {
    // sessionStorage can throw in private browsing - acting-as just won't persist, caller's
    // immediate navigation still works for this page load
  }
};

export const clearActingAsClient = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // see above
  }
};

// Spread into any outgoing API call's headers. Harmless to send on every authenticated request:
// only wallet-service's AccountantActingAsInterceptor currently reads this header at all - every
// other service's standard UserAuthorizationInterceptor doesn't look for it and just ignores it.
export const getActingAsHeader = () => {
  const actingAs = getActingAsClient();
  return actingAs?.clientUserId ? { "X-Acting-As-User-Id": actingAs.clientUserId } : {};
};
